module.exports = __webpack_public_path__ + "static/media/galerija_2017 (14).8c21b903.jpg";